<!--
 * @Author: your name
 * @Date: 2021-04-01 14:11:16
 * @LastEditTime: 2021-04-07 10:06:41
 * @LastEditors: Please set LastEditors
 * @Description: 第一次登录弹窗，为了密码安全
-->
<template>
  <div class="init-password-container">
    <a-modal
      wrapClassName="init-password-modal"
      :visible="true"
      :closable="false"
      :title="null"
      @cancel="handleCancel"
      :footer="null"
      :maskClosable="false"
    >
      <a-row class="modal-title">为保障你的账号安全，建议修改密码</a-row>
      <!-- 修改密码表单 -->
      <a-form-model
        class="init-password-form"
        ref="formRef"
        :model="form"
        :rules="rules"
        layout="vertical"
      >
        <!-- 设置新密码 -->
        <a-form-model-item
          label="输入新密码"
          prop="newPwd"
        >
          <a-input-password
            class="house-input-password"
            placeholder="请输入8-15位的字符，支持英文/数字/符号"
            v-model="form.newPwd"
            autocomplete="new-password"
          ></a-input-password>
        </a-form-model-item>

        <a-form-model-item
          label="再次输入新密码"
          prop="checkPwd"
        >
          <a-input-password
            class="house-input-password"
            placeholder="再输入一次新密码"
            autocomplete="new-password"
            v-model="form.checkPwd"
          ></a-input-password>
        </a-form-model-item>
      </a-form-model>

      <!-- 操作按钮 -->
      <a-row
        type="flex"
        justify="end"
        :gutter="20"
        class="operate-btn-group"
      >
        <a-col>
          <a-button @click="handleCancel">取消</a-button>
        </a-col>
        <a-col>
          <a-button
            type="primary"
            @click="handleOk"
          >确认</a-button>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>
<script>
import { initModifyPwd as modifyPwdApi } from '@/api/personal.js'
import { setStore } from '@/utils/storage.js'
export default {
  data () {
    return {
      form: {
        newPwd: "",
        checkPwd: ""
      },
      rules: {
        newPwd: [
          { required: true, message: "新密码必须填写" },
          {
            validator: (rule, value, callback) => {
              if (/[\s\u4E00-\u9FA5]+/.test(value)) {
                return Promise.reject(new Error("格式错误，请输入8-15位的字符"));
              } else {
                return Promise.resolve()
              }
            }
          },
          { min: 8, max: 15, message: "格式错误，请输入8-15位的字符", trigger: "blur" },
        ],
        checkPwd: [
          { required: true, message: "确认密码必须填写" },
          {
            validator: (rule, value, callback) => {
              let { newPwd } = this.form
              if (value !== newPwd) {
                return Promise.reject(new Error("新密码与确认密码不匹配"))
              } else {
                return Promise.resolve();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted () {
    setStore('isFirstLogin', 0)
  },
  methods: {
    handleOk () {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          let { newPwd } = this.form
          modifyPwdApi({
            password: newPwd
          }).then((res) => {
            if (res.code === 1000) {
              this.$message.success('修改成功')
              this.handleCancel()

              this.$store.dispatch('logout')
            } else {
              this.$message.warning(res.message)
            }
          })
        } else {
          this.$message.warning('信息填写不准确')
          return false
        }
      })
    },
    handleCancel () {
      this.$emit("openModal", false)
    }
  },
};
</script>
<style lang="less" scoped>
.operate-btn-group {
  margin-top: 100px;
  button {
    width: 104px;
    height: 40px;
  }
}
</style>
<style lang="less">
.init-password-modal {
  .modal-title {
    margin: 80px 0;
    font-size: 30px;
    font-weight: 600;
    color: #111;
  }
  .house-modal-content {
    width: 600px;
  }
}

// .house-input样式重写
.init-password-modal {
  .house-input-password {
    box-sizing: border-box;
    margin: 0;
    padding: 0 !important;
    font-size: 14px;
    position: relative;
    display: inline-block;
    width: 100%;
    text-align: start;
    border: none !important;
    &::before {
      content: '';
    }
  }
  .house-input-password > input.ant-input {
    box-sizing: border-box;
    margin: 0;
    padding: 8px 12px !important;
    padding-right: 30px;
    position: relative;
    display: inline-block;
    width: 100%;
    height: 40px;
    font-size: 14px;
    line-height: 1.5;
    border: 1px solid @border-color-base!important;
    border-radius: @border-radius-base;
    &:hover,
    &:active,
    &:focus {
      border: 1px solid @primary-color!important;
    }
    &::placeholder {
      color: @text-color-third;
    }
  }
  .house-input-password .ant-input-suffix {
    right: 12px;
    position: absolute;
    top: 50%;
    z-index: 2;
    display: flex;
    align-items: center;
    line-height: 0;
    transform: translateY(-50%);
    color: @text-color-third;
  }
  .has-error .house-input-password {
    .ant-input,
    .ant-input:hover {
      border: 1px solid @error-color!important;
    }
  }
}
</style>